import "./App.css";

import React from "react";
import MainNavigator from "./pages/router/Navigator";

const App = () => {
  return (
    <MainNavigator />
  );
};

export default App;
